// Copied From https://stackoverflow.com/questions/44115681/javascript-check-if-timezone-name-valid-or-not
export default function isValidTimeZone(tz: any) {
  // eslint-disable-next-line
  if (!Intl || !Intl.DateTimeFormat().resolvedOptions().timeZone) {
    throw new Error('Time zones are not available in this environment');
  }
  try {
    // eslint-disable-next-line
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch (ex) {
    return false;
  }
}

/**
 * Formats a date value.
 * @param date The value to parse to a date
 * @param timeZone Optional time zone to use when parsing the date.
 * @param fallbackMessage The string to return if formatting fails.
 * @returns The formatted date, or an unknown placeholder.
 */
export const dateFormatter = (date: string | number | Date, fallbackMessage: string, timeZone?: string): string => {
  if (!date) {
    return fallbackMessage;
  }

  if (timeZone && isValidTimeZone(timeZone)) {
    return new Date(date).toLocaleString('en-US', { timeZone: timeZone, timeZoneName: 'short' });
  }

  return new Date(date).toLocaleString();
};

export const formatTimestamp = (timestamp: number, locale: string): string => {
  let dateTimeFormatter: Intl.DateTimeFormat;
  try {
    dateTimeFormatter = new Intl.DateTimeFormat(locale);
  } catch (err) {
    return '???';
  }

  const formattedDate = dateTimeFormatter!.format(timestamp);
  if (formattedDate === undefined) {
    return '???';
  }

  return formattedDate;
};
